import Sidebar from '../utill/Sidebar'
import Header from "../utill/Header";
import Footer from "../utill/Footer";
import {Card, Form, Table} from "react-bootstrap";
import styles from "../../css/Authority.module.css"
import React, {ChangeEvent, Fragment, useContext, useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import {Checkbox} from "@mui/material";
import {RootState} from "../../redux/store";
import {MenuAuthority} from "../../redux/authority";

function AuthorityAdd() {
    const url = useContext(Url)
    const navigate = useNavigate();
    const nowUser = useSelector((state: RootState) => state.user.value);
    const [authorityId, setAuthorityId] = useState('');
    const [authorityName, setAuthorityName] = useState('');
    const [description, setDescription] = useState('');
    const [authority, setAuthority] = useState<Authority[]>([])

    const [disable, setDisable] = useState(true);
    let userId = nowUser.id;
    const auth = useSelector((state: RootState) => state.loginAuth.value);

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-권한 등록'
        if (auth.MENUAUTH?.SET0100?.readAuthorityYn !== "1" && auth.MENUAUTH?.SET0100?.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        else if (auth.MENUAUTH?.SET0100?.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate('/AuthorityManagement');
        }
        const menuAuth = Object.values(auth.MENUAUTH)
        let sortedMenuData = [...menuAuth].sort((a, b) => a.menuOrder - b.menuOrder);
        const commonChanges = {
            readAuthorityYn: false,
            writeAuthorityYn: false,
            loginId: userId,
        };
        // const propertiesToDelete = ['menuLevel', 'menuName','menuOrder','menuUrl','upperMenuCode'];
        const propertiesToDelete: (keyof  MenuAuthority)[] = ['menuOrder'];
        setAuthority(sortedMenuData.map(obj => {
            const changedElement = {...obj, ...commonChanges};
            for (const propertyToDelete of propertiesToDelete) {
                delete changedElement[propertyToDelete];
            }
            return changedElement;
        }))
    }, [])

    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            if (!authorityId || !authorityName) {
                alert('권한ID와 권한명은 필수 입력 항목입니다.');
                return;
            }
            const isAction = window.confirm('등록 하시겠습니까?');
            if (isAction) {
                try {
                    axios.post(url + 'authority/create', {
                        authorityId: authorityId,
                        authorityName: authorityName,
                        description: description,
                        loginId: userId,
                        menuAuthorityDtoList: authority
                    }, {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    }).then(() => {
                        alert('권한 등록 완료');
                        navigate('/AuthorityManagement');
                        }
                    )
                } catch (e) {
                    console.error(e);
                }
            }
        })
    };

    const handleModifyCancel = () => {
        const Cancel = window.confirm('취소하시겠습니까? 입력중인 내용이 모두 삭제됩니다.');
        if (Cancel) {
            navigate('/AuthorityManagement');
        }
    }

    const handleCheckId = () => {
        reissue(userId, url, navigate).then(() => {
            if (!authorityId) {
                alert('권한 아이디를 입력하세요');
            } else {
                axios.get(url + `authority/find`, {
                    headers: {
                        'Authorization': localStorage.getItem('Authorization')
                    },
                    params: {
                        data: authorityId,
                        type: 1
                    }
                })
                    .then(response => {
                        if (response.data.result.data.length === 0){
                            alert('사용 가능한 아이디입니다.')
                            setDisable(false);
                        }else {
                            alert('이미 사용중인 아이디입니다.')
                            setDisable(true);
                        }
                    })
                    .catch(error => {
                        console.error('아이디 중복 확인 실패:', error);
                    });
            }
        })
    };

    const handleIdChange = (e: ChangeEvent<HTMLInputElement>) => {
        setAuthorityId(e.target.value);
        setDisable(true);
    };

    const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        setAuthorityName(e.target.value);
    };

    const handleDescriptionChange = (e: ChangeEvent<HTMLInputElement>) => {
        setDescription(e.target.value);
    };


    const handleReadAuthorityYnChange = (menuCode: string, readAuthorityYn: boolean) => {
        setAuthority(authority.map(obj =>
            obj.menuCode === menuCode ? { ...obj, ['readAuthorityYn']: !readAuthorityYn } : obj
        ));
    }

    const handleWriteAuthorityYnChange = (menuCode: string,writeAuthorityYn: boolean) => {
        setAuthority(authority.map(obj =>
            obj.menuCode === menuCode ? {...obj, ['writeAuthorityYn']:!writeAuthorityYn} : obj
        ));
    }

    useEffect(() => {
        const targetObj = authority.find(obj =>
            obj.menuCode === "SET0000"
        );

        if(targetObj) {
            const menuCodes = ["SET0100", "SET0200", "SET0300"];

            const hasAuthority = menuCodes.some(code => {
                const obj = authority.find(obj => obj.menuCode === code);
                return obj && obj.readAuthorityYn;
            });
            targetObj.readAuthorityYn = hasAuthority;
        }
    }, [authority]);

    useEffect(() => {
        const targetObj = authority.find(obj =>
            obj.menuCode === "STAT0000"
        );

        if(targetObj) {
            const menuCodes = ["STAT0100", "STAT0200", "STAT0300"];

            const hasAuthority = menuCodes.some(code => {
                const obj = authority.find(obj => obj.menuCode === code);
                return obj && obj.readAuthorityYn;
            });
            targetObj.readAuthorityYn = hasAuthority;
        }
    }, [authority]);

    useEffect(() => {
        const targetObj = authority.find(obj =>
            obj.menuCode === "HIST0000"
        );

        if(targetObj) {
            const menuCodes = ["HIST0100", "HIST0200", "HIST0300"];

            const hasAuthority = menuCodes.some(code => {
                const obj = authority.find(obj => obj.menuCode === code);
                return obj && obj.readAuthorityYn;
            });
            targetObj.readAuthorityYn = hasAuthority;
        }
    }, [authority]);



    return (
        <div id="wrapper">
            <Sidebar menuCode={"SET0100"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='권한 등록'/>
                        <Card className="card shadow mb-4">
                            <Card.Body>
                                <Table bordered>
                                    <p style={{fontSize:'14px',marginBottom:'10px'}} className="before_required">표시는 필수 입력 항목입니다.</p>
                                    <tbody>
                                    <tr>
                                        <td style={{width: '20%'}} className={styles.tableHead}><p className="after_required">권한ID</p></td>
                                        <td style={{width: '100%'}}>
                                                <Form.Control type="text" placeholder="권한ID를 적어주세요" name="authorityId"
                                                              value={authorityId} onChange={handleIdChange}/>
                                                <button style={{marginLeft:'1rem'}} onClick={handleCheckId} className="btn btn-primary"
                                                    type="button">중복확인
                                                </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.tableHead}><p className="after_required">권한명</p></td>
                                        <td><Form.Control type="text" placeholder="권한명을 적어주세요" name="authorityName"
                                                          value={authorityName} onChange={handleNameChange}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.tableHead}>
                                            <p className="after_required">설명</p>
                                        </td>
                                        <td>
                                            <Form.Control  type="text"
                                                          placeholder="설명을 적어주세요" name="description"
                                                          value={description} onChange={handleDescriptionChange}/>
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>
                                <Table bordered className="text-center">
                                    <thead>
                                    <tr>
                                        <th colSpan={2} className={styles.tableHead}>메뉴 명</th>
                                        <th className={styles.tableHead}>읽기</th>
                                        <th className={styles.tableHead}>쓰기</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {authority
                                        .filter((menu) => menu.menuLevel === 1)
                                        .map((menu) => (
                                            <Fragment key={menu.menuCode}>
                                                {menu.menuUrl ? (
                                                    <tr>
                                                        <td colSpan={2}>{menu.menuName}</td>
                                                        <td>
                                                            <Checkbox
                                                                checked={menu.readAuthorityYn}
                                                                onChange={() => handleReadAuthorityYnChange(menu.menuCode, menu.readAuthorityYn)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Checkbox
                                                                checked={menu.writeAuthorityYn}
                                                                onChange={() => handleWriteAuthorityYnChange(menu.menuCode, menu.writeAuthorityYn)}
                                                            />
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        <tr>
                                                            <th colSpan={2} style={{verticalAlign: 'middle'}}
                                                                className={styles.tableHead}>{menu.menuName}</th>
                                                            <th colSpan={2} className={styles.tableHead}></th>
                                                        </tr>
                                                        {authority
                                                            .filter((subMenu) => subMenu.upperMenuCode === menu.menuCode)
                                                            .map((subMenu) => (
                                                                <Fragment key={subMenu.menuCode}>
                                                                    <tr>
                                                                    <td className={styles.tableBody} colSpan={2}>{subMenu.menuName}</td>
                                                                        <td className={styles.tableBody}>
                                                                            <Checkbox
                                                                                checked={subMenu.readAuthorityYn}
                                                                                onChange={() => handleReadAuthorityYnChange(subMenu.menuCode, subMenu.readAuthorityYn)}
                                                                        />
                                                                    </td>
                                                                    <td className={styles.tableBody}>
                                                                        <Checkbox
                                                                            checked={subMenu.writeAuthorityYn}
                                                                            onChange={() => handleWriteAuthorityYnChange(subMenu.menuCode, subMenu.writeAuthorityYn)}
                                                                        />
                                                                    </td>
                                                                    </tr>
                                                                </Fragment>
                                                            ))}
                                                    </>
                                                )}
                                            </Fragment>
                                        ))}
                                    </tbody>
                                </Table>
                                <div className="btn modify">
                                    <button className="btn btn-primary" disabled={disable}
                                            onClick={handleSubmit} type="submit">등록
                                    </button>
                                    <button className="btn btn-secondary" onClick={handleModifyCancel}>취소
                                    </button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}

export default AuthorityAdd;